import { Component, Prop, Vue } from 'vue-property-decorator';
import Header from '../../shared/Header/header.vue';
import NavSide from '../../shared/NavSide/nav.side.vue';

@Component({
   components: {
      Header,
      NavSide,
   },
})
export default class Home extends Vue {
   public title: string = 'Home';

   public onContactButtonClick() {
      window.open('http://rifo.ca');
      // this.$router.push('http://rifo.ca');
   }

   get count() {
      return this.$store.state.count;
   }
}
